import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { FaPhone, FaBars, FaTimes, FaHome, FaUserMd, FaHandsHelping, FaImages, FaEnvelope } from 'react-icons/fa';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navItems = [
    { name: 'Home', path: '/', icon: <FaHome /> },
    { name: 'About Us', path: '/about', icon: <FaUserMd /> },
    { name: 'Services', path: '/services', icon: <FaHandsHelping /> },
    { name: 'Gallery', path: '/gallery', icon: <FaImages /> },
    { name: 'Contact', path: '/contact', icon: <FaEnvelope /> },
  ];

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
  {/* Logo */}
  <Link to="/" className="flex items-center space-x-3">
    <img
      src="/logo.svg"
      alt="Lerito Home Care Logo"
      className="w-12 h-12"
    />

    <div>
      <h1 className="text-2xl font-bold text-gray-800 font-poppins">
        Lerito Healthcare 
      </h1>
      <p className="text-sm text-gray-600">Home Care, india</p>
    </div>
  </Link>

  {/* Desktop Navigation */}
  <nav className="hidden md:flex items-center space-x-8">
    {navItems.map((item) => (
      <NavLink
        key={item.name}
        to={item.path}
        className={({ isActive }) =>
          `flex items-center space-x-2 px-3 py-2 rounded-lg transition-colors ${
            isActive
              ? 'text-health-blue bg-blue-50 font-semibold'
              : 'text-gray-700 hover:text-health-blue hover:bg-blue-50'
          }`
        }
      >
        {item.icon}
        <span>{item.name}</span>
      </NavLink>
    ))}
  </nav>

  {/* Contact Button */}
  <div className="hidden md:flex items-center space-x-4">
    <a
      href="tel:+918266958207"
      className="flex items-center space-x-2 bg-health-blue text-white px-6 py-3 rounded-full hover:bg-blue-700 transition-colors shadow-lg"
    >
      <FaPhone />
      <span>Emergency: +91 8266958207</span>
    </a>
  </div>

  {/* Mobile Menu Button */}
  <button
    className="md:hidden text-gray-700 text-2xl"
    onClick={() => setIsMenuOpen(!isMenuOpen)}
  >
    {isMenuOpen ? <FaTimes /> : <FaBars />}
  </button>
</div>


        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4">
            <div className="flex flex-col space-y-2">
              {navItems.map((item) => (
                <NavLink
                  key={item.name}
                  to={item.path}
                  onClick={() => setIsMenuOpen(false)}
                  className={({ isActive }) =>
                    `flex items-center space-x-3 px-4 py-3 rounded-lg ${
                      isActive
                        ? 'text-health-blue bg-blue-50 font-semibold'
                        : 'text-gray-700 hover:text-health-blue hover:bg-blue-50'
                    }`
                  }
                >
                  {item.icon}
                  <span>{item.name}</span>
                </NavLink>
              ))}
              <a
                href="tel:+918266958207"
                className="flex items-center justify-center space-x-2 bg-health-blue text-white px-4 py-3 rounded-lg mt-2"
                onClick={() => setIsMenuOpen(false)}
              >
                <FaPhone />
                <span>Emergency Call</span>
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;